import Dropzone from 'dropzone';
import toastr from 'toastr/toastr.js';

/**
 * PosterEditor Component
 */

/**
 * Default Settings
 */
const defaults = {
    minWidth: 400,
    dropzone: {
        url: '/api/preview',
        clickable: '[data-js-posteditor-dropzone]',
        dropzone: '#posteditor-dropzone',
        previewsContainer: '#posteditor-dropzone-preview', // Does not seem to work: '[data-js-posteditor-dropzone-preview]'
        autoProcessQueue: true,
        addRemoveLinks: true,
        maxFiles: 2,
        dictMaxFilesExceeded: 'Es kann nur 1 Bild hochgeladen werden.',
        dictFallbackText: '',
        dictRemoveFile: '×',
        dictCancelUpload: '×'
    },
    api: {
        imgurl: '/api/preview'
    }
};
const pluginName = "posterEditor";


/**
 * Attach and initialize the component
 */
$.fn.posterEditor = function (options) {
    return this.each(function () {

        /** Prevent against multiple instantiations */
        if ((typeof options === 'undefined' || typeof options === 'object')
            && !$.data(this, 'plugin_' + pluginName))
        {
            $.data(this, 'plugin_' + pluginName, new Plugin(this, options));

        /** Accept commands on already initialized objects */
        } else if (typeof options === 'string' && $.data(this, 'plugin_' + pluginName)) {

            switch(options) {
                case 'log':
                    //console.log($.data(this, 'plugin_' + pluginName));
                    break;
                case 'editor':
                    return $.data(this, 'plugin_' + pluginName);
                    break;
                default:
                    break;
            }
        }
    });
};

/**
 * Constructor
 */
function Plugin (element, options) {

    this.options = $.extend(true, {}, defaults, options);
    this.options.namespace = this.options.namespace || $(element).attr('data-js-postereditor') || Math.random().toString(36).replace('.','');
    this.options.dropzone.headers = { 'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]').value };
    this._defaults = defaults;
    this._name = pluginName;
    this.element = element;

    this.state = {};

    this.init();
}

/**
 * Methods
 */
Plugin.prototype = $.extend(true, {}, Plugin.prototype, {
    /** Main initialization function */
    init: function () {
        this.initState();
        this.initColorPicker('bgcolor');
        this.initColorPicker('fgcolor');
        this.initColorPicker('pattern');
        this.initPreview();
        this.initSpinner();
        this.initDropzone();
        this.update();
    },
    /** Initialize state setters and getters */
    initState: function () {
        this.state = {
            get bgcolor()  { return this._bgcolor; },
            set bgcolor(c) { this._bgcolor = c.toString(); },
            get fgcolor()  { return this._fgcolor; },
            set fgcolor(c) { this._fgcolor = c.toString(); },
            get pattern()  { return this._pattern; },
            set pattern(p) { this._pattern = p.toString(); },
            imgid: false
        }
    },
    /**
     * Initialize colorpicker / select elements
     * @param {string} attribute - The type for the color picker (e.g. 'bgcolor'). Used for all attribute names.
     */
    initColorPicker: function (attribute) {
        attribute = attribute || 'color'
        this[attribute] = {
            $root: $(this.element).find('[data-js-postereditor-colorpicker='+attribute+']'),
            colors: []
        };
        this[attribute].$colorSelect = this[attribute].$root.find('[data-js-postereditor-colorpicker-select]');
        this[attribute].$colorPicker = this[attribute].$root.find('[data-js-postereditor-colorpicker-picker]');

        var that = this;
        this[attribute].$colors = this[attribute].$colorPicker.find('[data-js-postereditor-colorpicker-color]');



        this[attribute].$colorSelect.each(function () {
            $(this).children('option').each(function () {
                that[attribute].colors.push($(this).attr('value'));
            });
        });

        this[attribute].$colorSelect.on('change.'+this.options.namespace, function () {
            var val = $(this).val();
            that[attribute].$colors.removeClass('is-active');
            that[attribute].$colors.filter('[data-js-postereditor-colorpicker-color='+val+']').addClass('is-active');
            that.state[attribute] = val;
            that.update();
        });

        this[attribute].$colors.on('click.'+this.options.namespace, function () {
            var val = $(this).attr('data-js-postereditor-colorpicker-color');
            if (!$(this).hasClass('is-disabled') && val != that.state[attribute]) {
                that[attribute].$colors.removeClass('is-active');
                $(this).addClass('is-active');
                that[attribute].$colorSelect.val(val);
                that.state[attribute] = val;
                that.update();
            }
        });

        this.state[attribute] = this[attribute].$colorSelect.val();

        /**
        * This prevents the error:
        * Uncaught Error: Syntax error, unrecognized expression: [data-js-postereditor-colorpicker-color=]
        * when the state attribute is not set.
        */
        if (this.state[attribute]) this[attribute].$colors.filter('[data-js-postereditor-colorpicker-color='+this.state[attribute]+']').addClass('is-active');
    },
    initPreview: function () {
        var that = this;
        this.$preview = $(this.element).find('[data-js-postereditor-preview-img]');
        this.$preview.bind('load.postereditor', function () {
            that.showSpinner(false);
        }).each(function(){
            if (this.complete || this.complete === undefined) { this.src = this.src; } //needed for potential cached images
            //console.log(this.complete)
        });
    },
    initDropzone: function () {
        var that = this;
        this.dropzone = new Dropzone(this.options.dropzone.dropzone,
                                    $.extend(true, {}, this.options.dropzone, {
                                        success: function (result, data) {
                                            if (this.files.length > 1) {
                                                this.removeFile(this.files[0]);
                                            }
                                            that.state.imgid = data;
                                            $('#input-event-file-id').val(data);
                                            //that.showSpinner(true);
                                            that.update();
                                        },
                                        error: function (error, errorMessage) {
                                            toastr.error(errorMessage);
                                            this.removeAllFiles();
                                        },
                                        fallback: function() {
                                            $('[data-js-posteditor-dropzone]').addClass('fallback-active');
                                        }
                                    }));

        this.dropzone.on('removedfile', function(file) {
            that.removePreview();
        });
    },
    initSpinner: function () {
        this.$spinnerRects = $(this.element).find('[data-js-poster-editor-spinner-rect]');
        this.$spinner = $(this.element).find('[data-js-poster-editor-spinner]');
        this.updateSpinner();
    },
    update: function () {
        this.updatePreview();
        this.updateSpinner();
        this.updateColors();
    },
    updatePreview: function () {
        this.$preview.attr('src', this.getImageUrl());
        this.showSpinner(true);
    },
    updateSpinner: function () {
        this.$spinnerRects.css({ 'backgroundColor': this.state.fgcolor });
        this.$preview.each(function () {
            if (this.complete || this.complete === undefined) { this.src = this.src; }
        });
    },
    updateColors: function () {
        /**
         * Disallow the same value on fgcolor and bgcolor
         *
         * NOTE: This is not very generic or DRY, but it serves the purpose
         */
        var valFgColor = this['fgcolor'].$colorSelect.val(),
            valBgColor = this['bgcolor'].$colorSelect.val();

        this['fgcolor'].$colors.removeClass('is-disabled');
        this['fgcolor'].$colors.filter('[data-js-postereditor-colorpicker-color='+this.state['bgcolor']+']').addClass('is-disabled');
        this['fgcolor'].$colorSelect.children('option').each(function () {
            $(this).attr('disabled', $(this).val() == valBgColor);
        });
        this['bgcolor'].$colors.removeClass('is-disabled');
        this['bgcolor'].$colors.filter('[data-js-postereditor-colorpicker-color='+this.state['fgcolor']+']').addClass('is-disabled');
        this['bgcolor'].$colorSelect.children('option').each(function () {
            $(this).attr('disabled', $(this).val() == valFgColor);
        });
    },
    removePreview: function () {
        this.showSpinner(true);
        this.state.imgid = null;
        this.$preview.attr('src', this.getImageUrl());
        this.showSpinner(false);
    },
    showSpinner: function (shouldShow) {
        shouldShow = (typeof shouldShow !== 'undefined') ? !!shouldShow : true;
        this.$spinner.toggleClass('is-active', shouldShow);
    },
    getImageUrl: function () {
        var baseUrl = this.options.api.imgurl,
            s = this.state;
            if ((s.bgcolor || s.imgid !== false) && s.fgcolor && s.pattern) {
            if (s.imgid) {
                baseUrl += '?image='+s.imgid+'&fgcolor='+encodeURIComponent(s.fgcolor)+'&pattern='+s.pattern;
            } else {
                baseUrl += '?bgcolor='+encodeURIComponent(s.bgcolor)+'&fgcolor='+encodeURIComponent(s.fgcolor)+'&pattern='+s.pattern;
            }
        }
        return baseUrl;
    }

});

export default true;



// WEBPACK FOOTER //
// ./src/js/app/components/postereditor.js